/** En dev sans VITE_API_URL : chaîne vide → URLs relatives `/api/...` via le proxy Vite (évite d’appeler le port du frontend et de recevoir du HTML). */
export const API_URL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? '' : '');

export const APP_CONFIG = {
  title: 'SOS IT Services - Dépannage Informatique Professionnel',
  /** Fichier statique dans `public/` — évite les data URLs (CSP / onglet avant hydratation). */
  favicon: '/favicon.svg',
  routes: {
    home: '/',
    depannage: '/depannage-informatique',
    creationSite: '/creation-site-web',
    monEspace: '/mon-espace',
    tickets: '/tickets/:id',
    expertsMap: '/experts-map',
    politiqueConfidentialite: '/politique-de-confidentialite',
    mentionsLegales: '/mentions-legales',
    conditionsUtilisation: '/conditions-utilisation',
    blog: '/blog',
    blogSilo: '/blog/silo/:siloId',
    blogArticle: '/blog/:slug',
    depannageGenevois: '/depannage-informatique-genevois',
    depannageSaintJulien: '/depannage-informatique-saint-julien-en-genevois',
    depannageAnnemasse: '/depannage-informatique-annemasse',
    depannageAnnecy: '/depannage-informatique-annecy',
    depannageGex: '/depannage-informatique-gex',
    depannageViry: '/depannage-informatique-viry',
    depannageValleiry: '/depannage-informatique-valleiry',
    depannageSaintGenis: '/depannage-informatique-saint-genis-pouilly',
    depannageFerney: '/depannage-informatique-ferney-voltaire',
    depannageDivonne: '/depannage-informatique-divonne-les-bains',
    depannagePrevessin: '/depannage-informatique-prevessin-moens',
    depannageArchamps: '/depannage-informatique-archamps',
    depannageCollonges: '/depannage-informatique-collonges-sous-saleve',
    depannageOrnex: '/depannage-informatique-ornex',
    depannageCessy: '/depannage-informatique-cessy',
    depannageSegny: '/depannage-informatique-segny',
    depannageGeneve: '/depannage-informatique-geneve',
  },
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  // Map ID nécessaire pour Google Advanced Markers (AdvancedMarkerElement)
  googleMapsMapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '',
}; 